<template>
  <DialogueBox
    data-auto-id="token-delete-dialogue"
    :showing="showing"
    title="Confirm Deletion"
  >
    <div class="p-4">
      <p>Are you sure you want to delete this record?</p>
      <dl class="mb-8">
        <dt data-auto-id="record-delete-type" class="font-bold">
          {{ record.meta.type }}
        </dt>
        <dd data-auto-id="record-delete-id" class="text-tiny text-gray-dark">
          {{ record.meta.recordId }}
        </dd>
      </dl>
      <div class="flex items-center">
        <button
          data-auto-id="record-delete-confirm"
          @click.prevent="$emit('confirm')"
          class="m-0 mr-4"
        >
          Confirm
        </button>
        <a
          href="#!"
          @click.prevent="$emit('cancel')"
          class="text-gray-darkest no-underline"
          >Cancel</a
        >
      </div>
    </div>
  </DialogueBox>
</template>

<script>
import DialogueBox from '@/Common/DialogueBox'
export default {
  name: 'RecordDeleteDialogue',
  components: {
    DialogueBox,
  },
  props: {
    showing: Boolean,
    record: Object,
  },
}
</script>
